/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ExternalSourceLightSpreadsheetSheet'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ExternalSourceLightSpreadsheetSheet'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ExternalSourceLightSpreadsheet = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ExternalSourceLightSpreadsheetSheet);
  }
}(this, function(ApiClient, ExternalSourceLightSpreadsheetSheet) {
  'use strict';




  /**
   * The ExternalSourceLightSpreadsheet model module.
   * @module model/ExternalSourceLightSpreadsheet
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ExternalSourceLightSpreadsheet</code>.
   * @alias module:model/ExternalSourceLightSpreadsheet
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>ExternalSourceLightSpreadsheet</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ExternalSourceLightSpreadsheet} obj Optional instance to populate.
   * @return {module:model/ExternalSourceLightSpreadsheet} The populated <code>ExternalSourceLightSpreadsheet</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('SheetExcelID')) {
        obj['SheetExcelID'] = ApiClient.convertToType(data['SheetExcelID'], 'Integer');
      }
      if (data.hasOwnProperty('SheetGoogleID')) {
        obj['SheetGoogleID'] = ApiClient.convertToType(data['SheetGoogleID'], 'Integer');
      }
      if (data.hasOwnProperty('Sheets')) {
        obj['Sheets'] = ApiClient.convertToType(data['Sheets'], [ExternalSourceLightSpreadsheetSheet]);
      }
    }
    return obj;
  }

  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Integer} SheetExcelID
   */
  exports.prototype['SheetExcelID'] = undefined;
  /**
   * @member {Integer} SheetGoogleID
   */
  exports.prototype['SheetGoogleID'] = undefined;
  /**
   * @member {Array.<module:model/ExternalSourceLightSpreadsheetSheet>} Sheets
   */
  exports.prototype['Sheets'] = undefined;



  return exports;
}));


